export default __webpack_public_path__ + "static/media/impact-strategy.b64f1451.svg";